import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatIconButton } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatToolbar } from '@angular/material/toolbar'
import { ElderHeaderComponent, ElderThemeDirective } from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { WorkItem } from '../../../../orders/work-items/work-item'
import { ControlTerminal } from '../../../control-terminal'
import { TerminalWorkItemDetailComponent } from '../terminal-work-item-detail/terminal-work-item-detail.component'

export interface ITerminalWorkItemDialogOptions {
  readonly item: WorkItem
  readonly controlTerminal: ControlTerminal
  readonly workCenterId: string
  readonly printingEnabled: boolean
}

@Component({
  selector: 'app-terminal-work-item-dialog',
  templateUrl: './terminal-work-item-dialog.component.html',
  styleUrls: ['./terminal-work-item-dialog.component.scss'],
  imports: [
    MatToolbar,
    ElderThemeDirective,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    TerminalWorkItemDetailComponent,
    ElderTranslatePipe,
    ElderHeaderComponent,
  ],
})
export class TerminalWorkItemDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly item: WorkItem
  public readonly controlTerminal: ControlTerminal
  public readonly workCenterId: string
  public readonly printingEnabled: boolean

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<ITerminalWorkItemDialogOptions>(MAT_DIALOG_DATA)
    this.item = data.item
    this.controlTerminal = data.controlTerminal
    this.workCenterId = data.workCenterId
    this.printingEnabled = data.printingEnabled
  }
}
